import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss'],
})
export class InsuranceComponent implements OnInit {
  @Input() isAuthenticated!: boolean;
  @Input() hasInsuranceCosts!: boolean;
  constructor(private router: Router) {}

  ngOnInit(): void {}

  goToInsuranceForm() {
    this.router.navigate(['/insurance-form/input']);
  }
}
